import React from 'react';

const Loading = () => {
	return (
		<div className="loading">
			<h1>loading...</h1>
		</div>
	);
};

export default Loading;
